import {useAxiosClient} from "~/use/axios/client";
import {
    GmModelLibraryModelsContractsTimberPriceAreaMappingModel,
    GmModelLibraryModelsContractsTimberPriceListModel,
    GmModelLibraryModelsContractsTimberPriceListType, TimberPriceListApi
} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {queryClient} from "~/plugins/vue-query";

export const usePriceListService = () => {
    const { axiosClient } = useAxiosClient()
    const timberPriceListApi = new TimberPriceListApi(undefined, '', axiosClient.value)

    const defaultOptions = {
        staleTime: MS_HOUR,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        gcTime: Infinity,
    }

    const priceListsQueryOptions: UseQueryOptions<GmModelLibraryModelsContractsTimberPriceListModel[]> = {
        queryKey: ['timberPriceListGetTimberPriceList'],
        queryFn: async () => {
            return (await timberPriceListApi.timberPriceListGetTimberPriceList())?.data
        },
        ...defaultOptions
    }

    const priceListsQuery = () => useQuery(priceListsQueryOptions)

    const priceListAreasQueryOptions: UseQueryOptions<GmModelLibraryModelsContractsTimberPriceAreaMappingModel[]> = {
        queryKey: ['timberPriceListGetTimerPriceListsAreaList'],
        queryFn: async () => {
            return (await timberPriceListApi.timberPriceListGetTimerPriceListsAreaList())?.data
        },
        ...defaultOptions
    }

    const priceListAreasQuery = () => useQuery(priceListAreasQueryOptions)

    const priceTypesQueryOptions: UseQueryOptions<GmModelLibraryModelsContractsTimberPriceListType[]> = {
        queryKey: ['timberPriceListGetTimberPriceTypes'],
        queryFn: async () => {
            return (await timberPriceListApi.timberPriceListGetTimberPriceTypes())?.data
        },
        ...defaultOptions
    }

    const priceTypesQuery = () => useQuery(priceTypesQueryOptions)

    const getPriceListById = (id: string) => {
        const priceLists = (queryClient.getQueryData(priceListsQueryOptions.queryKey) || []) as GmModelLibraryModelsContractsTimberPriceListModel[]
        return priceLists?.find((p) => p.Id === id)
    }

    const getPriceListByPriceListNumber = (listNumber: string) => {
        const priceLists = (queryClient.getQueryData(priceListsQueryOptions.queryKey) || []) as GmModelLibraryModelsContractsTimberPriceListModel[]
        return priceLists.find((p) => p.PriceListNumber === listNumber)
    }

    const getPriceListAreasByMunicipalityId = (municipalityId: string) => {
        const priceListAreas = (queryClient.getQueryData(priceListAreasQueryOptions.queryKey) || []) as GmModelLibraryModelsContractsTimberPriceAreaMappingModel[]
        return priceListAreas.filter((area) => area.MunicipalityId === municipalityId)
    }

    return {
        priceListsQueryOptions,
        priceListAreasQueryOptions,
        priceTypesQueryOptions,
        priceListsQuery,
        priceListAreasQuery,
        priceTypesQuery,
        getPriceListById,
        getPriceListByPriceListNumber,
        getPriceListAreasByMunicipalityId,
    }
}